import React from 'react'
import { MainLayout } from './MainLayout'

interface Props {
  children?: React.ReactNode
  title?: string
  description?: string
  image?: string
  twitterDescription?: string
  twitterImage?: string
  canonicalPath?: string
}

export const MainLayoutV2: React.FC<Props> = (props: Props) => {
  return (
    <>
      <MainLayout {...props}>
        <div
          className="--v2 --v2-container flex flex-column"
          id="creatorland-root"
        >
          {props.children}
        </div>
      </MainLayout>
    </>
  )
}
